export default __webpack_public_path__ + "static/media/ep_15.974f660b.png";